import ListMembers from "../../../../components/@users/members/ListMembers";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

import { ownerTypes } from "../../../../schema/users/memberSchema";

import { useAuthAccess } from "../../../../hooks/useAuthAccess";

export default function MembersPage() {

    const { authData } = useAuthAccess()

    // console.log('authData', authData)

    let ownerId = authData?.profile?.user?.id

    return (
        <ListMembers 
            routeType={routeTypes.retail}
            ownerType={ownerTypes.retailer}
            ownerId={ownerId}
        />
    )

}       